/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements, getAllowedOutputs } from '../block_compatibility_checks';

// --------------------------- SEPARATE DATA SELECTION C BLOCKS------------------

/*
* C-Block dropdown for selecting satellite
*/
Blockly.Blocks['input_optical_data_only'] = {
    init: function () {
        this.appendDummyInput()
            .appendField("Satellite:    ")
            .appendField(new Blockly.FieldDropdown([['Landsat\u00A08', 'l8'], ['Landsat\u00A07', 'l7'], ['Landsat\u00A05', 'l5'], ['Landsat\u00A04', 'l4'], ['Sentinel-2', 's2']]), "dropdown");
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('optical_data'));
        this.setInputsInline(false);
        this.setPreviousStatement(true, 'optical_data');
        this.setNextStatement(true, getAllowedOutputs('optical_data'));
        this.setStyle('input');
        this.setTooltip(Blockly.Msg.SATELLITE_BLOCK_TOOLTIP);
        this.setHelpUrl("");
    }
};